import { useQuery } from '@tanstack/react-query';
import { formatDateTime } from '../../../lib/format';
import { recentAuditQuery } from '../queries';
import {
  RowTitle,
  WidgetCard,
  WidgetEmpty,
  WidgetError,
  WidgetList,
  WidgetRow,
  WidgetSkeleton,
} from '../primitives';

/** Who changed what, lately. Needs `audit.read`, which the API also enforces. */
export function RecentAuditWidget({ limit = 6, to }: { limit?: number; to?: string }) {
  const query = useQuery(recentAuditQuery(limit));

  return (
    <WidgetCard
      title="Recent activity"
      description="Attributed changes across the system."
      to={to}
      toLabel="Full audit trail"
    >
      {query.isPending ? <WidgetSkeleton rows={2} /> : null}
      {query.isError ? (
        <WidgetError label="Could not load the audit trail." onRetry={() => void query.refetch()} />
      ) : null}
      {query.isSuccess && query.data.items.length === 0 ? (
        <WidgetEmpty>Nothing recorded yet.</WidgetEmpty>
      ) : null}
      {query.isSuccess && query.data.items.length > 0 ? (
        <WidgetList>
          {query.data.items.map((entry) => (
            <WidgetRow key={entry.id}>
              <RowTitle
                title={entry.action}
                subtitle={`${entry.entityType} · ${entry.actorName ?? 'system'} · ${formatDateTime(entry.createdAt)}`}
              />
            </WidgetRow>
          ))}
        </WidgetList>
      ) : null}
    </WidgetCard>
  );
}
